import { observable } from "mobx";
import { Type } from "class-transformer";
import AdvanceListItem from "./advanceListItem";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AdvanceList {
  @observable
  total!: number;

  @observable
  @Type(() => AdvanceListItem)
  advances!: AdvanceListItem[];

  static ValidationRules = {
    total: { required: true, number: true },
    advances: { required: true },
  };
}
